// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.certhis",
    name: "Certhis",
    homepage: "https://certhis.io",
    image_id: "fbd441cc-e861-46dc-48ae-a04228ddb500",
    app: {
        browser: "https://explorer.certhis.io",
        ios: null,
        android: null,
        mac: "",
        windows: null,
        linux: "https://certhis.io/",
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://certhis.io/",
    },
    desktop: {
        native: null,
        universal: "https://certhis.io",
    },
};
//# sourceMappingURL=index.js.map